import * as i0 from '@angular/core';
import { EventEmitter, inject, DestroyRef, Component, Output, Input, contentChild, effect, computed } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/tree';
import { MatTreeFlattener, MatTreeFlatDataSource, MatTreeModule } from '@angular/material/tree';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import * as i6 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i7 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BehaviorSubject } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { cloneDeep } from 'lodash';
import { MycdkContextMenuComponent } from '@em4cloud/my-cdk';
import * as i1 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
const _c0 = ["leafNode"];
const _c1 = ["expandableNode"];
const _c2 = a0 => ({
  node: a0
});
const _c3 = a0 => ({
  $implicit: a0
});
function TreeViewComponent_mat_tree_node_1_mat_checkbox_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 11);
    i0.ɵɵlistener("change", function TreeViewComponent_mat_tree_node_1_mat_checkbox_3_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const node_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.checkBoxChange($event, node_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data-test-id", "toggle_" + ctx_r2.getNodeId(node_r4.title))("id", "toggle_" + ctx_r2.getNodeId(node_r4.title))("checked", ctx_r2.selectedNode && ctx_r2.selectedNode.id && ctx_r2.selectedNode.id === node_r4.id);
  }
}
function TreeViewComponent_mat_tree_node_1_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 12);
  }
  if (rf & 2) {
    const node_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("svgIcon", node_r4.icon);
  }
}
function TreeViewComponent_mat_tree_node_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
  }
  if (rf & 2) {
    const node_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.leafNodeTemplateRef())("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, node_r4));
  }
}
function TreeViewComponent_mat_tree_node_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    const node_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", node_r4.title, i0.ɵɵsanitizeHtml);
  }
}
function TreeViewComponent_mat_tree_node_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tree-node", 4);
    i0.ɵɵlistener("cdkDragStarted", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_cdkDragStarted_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragStart());
    })("cdkDragReleased", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_cdkDragReleased_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragEnd($event));
    })("cdkDragMoved", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_cdkDragMoved_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragMove($event));
    })("mouseenter", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_mouseenter_0_listener($event) {
      const node_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragHover($event, node_r4));
    })("mouseleave", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_mouseleave_0_listener() {
      const node_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragHoverEnd(node_r4));
    })("mousedown", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeCursor($event, "move"));
    })("mouseup", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_mouseup_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeCursor($event, "default"));
    })("click", function TreeViewComponent_mat_tree_node_1_Template_mat_tree_node_click_0_listener() {
      const node_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.treeNodeClicked(node_r4));
    });
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "button", 6);
    i0.ɵɵtemplate(3, TreeViewComponent_mat_tree_node_1_mat_checkbox_3_Template, 1, 3, "mat-checkbox", 7)(4, TreeViewComponent_mat_tree_node_1_mat_icon_4_Template, 1, 1, "mat-icon", 8)(5, TreeViewComponent_mat_tree_node_1_Conditional_5_Template, 1, 4, "ng-container", 9)(6, TreeViewComponent_mat_tree_node_1_Conditional_6_Template, 1, 1, "span", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const menu_r6 = i0.ɵɵreference(4);
    i0.ɵɵclassProp("selectedNode", ctx_r2.selectedNode && ctx_r2.selectedNode.id && ctx_r2.selectedNode.id === node_r4.id);
    i0.ɵɵproperty("data-test-id", "treeNode_" + ctx_r2.getNodeId(node_r4.title))("id", "treeNode_" + ctx_r2.getNodeId(node_r4.title))("matTreeNodePaddingIndent", ctx_r2.treeNodePaddingIndent)("cdkDragData", node_r4)("cdkContextMenuDisabled", !(ctx_r2.treeConfig == null ? null : ctx_r2.treeConfig.contextMenuConfig == null ? null : ctx_r2.treeConfig.contextMenuConfig.enableContextMenu))("cdkContextMenuTriggerFor", menu_r6)("cdkContextMenuTriggerData", i0.ɵɵpureFunction1(13, _c2, node_r4))("ngClass", node_r4.class);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r4.checkbox);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r4.icon);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.leafNodeTemplateRef() ? 5 : 6);
  }
}
function TreeViewComponent_mat_tree_node_2_mat_checkbox_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 11);
    i0.ɵɵlistener("change", function TreeViewComponent_mat_tree_node_2_mat_checkbox_4_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const node_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.checkBoxChange($event, node_r8));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data-test-id", "toggle_" + ctx_r2.getNodeId(node_r8.title))("id", "toggle_" + ctx_r2.getNodeId(node_r8.title))("checked", ctx_r2.selectedNode && ctx_r2.selectedNode.id && ctx_r2.selectedNode.id === node_r8.id);
  }
}
function TreeViewComponent_mat_tree_node_2_mat_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 12);
  }
  if (rf & 2) {
    const node_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("svgIcon", node_r8.icon);
  }
}
function TreeViewComponent_mat_tree_node_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 9);
  }
  if (rf & 2) {
    const node_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.expandableNodeTemplateRef())("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, node_r8));
  }
}
function TreeViewComponent_mat_tree_node_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    const node_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", node_r8.title, i0.ɵɵsanitizeHtml);
  }
}
function TreeViewComponent_mat_tree_node_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-tree-node", 4);
    i0.ɵɵlistener("cdkDragStarted", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_cdkDragStarted_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragStart());
    })("cdkDragReleased", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_cdkDragReleased_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragEnd($event));
    })("cdkDragMoved", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_cdkDragMoved_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragMove($event));
    })("mouseenter", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_mouseenter_0_listener($event) {
      const node_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragHover($event, node_r8));
    })("mouseleave", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_mouseleave_0_listener() {
      const node_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dragHoverEnd(node_r8));
    })("mousedown", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeCursor($event, "move"));
    })("mouseup", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_mouseup_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeCursor($event, "default"));
    })("click", function TreeViewComponent_mat_tree_node_2_Template_mat_tree_node_click_0_listener() {
      const node_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.treeNodeClicked(node_r8));
    });
    i0.ɵɵelementStart(1, "div", 5)(2, "button", 13);
    i0.ɵɵlistener("click", function TreeViewComponent_mat_tree_node_2_Template_button_click_2_listener() {
      const node_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onNodeToggled(node_r8));
    });
    i0.ɵɵelement(3, "mat-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TreeViewComponent_mat_tree_node_2_mat_checkbox_4_Template, 1, 3, "mat-checkbox", 7)(5, TreeViewComponent_mat_tree_node_2_mat_icon_5_Template, 1, 1, "mat-icon", 8)(6, TreeViewComponent_mat_tree_node_2_Conditional_6_Template, 1, 4, "ng-container", 9)(7, TreeViewComponent_mat_tree_node_2_Conditional_7_Template, 1, 1, "span", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r8 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const menu_r6 = i0.ɵɵreference(4);
    i0.ɵɵclassProp("selectedNode", ctx_r2.selectedNode && ctx_r2.selectedNode.id && ctx_r2.selectedNode.id === node_r8.id);
    i0.ɵɵproperty("data-test-id", "treeNode_" + ctx_r2.getNodeId(node_r8.title))("id", "treeNode_" + ctx_r2.getNodeId(node_r8.title))("matTreeNodePaddingIndent", ctx_r2.treeNodePaddingIndent)("cdkDragData", node_r8)("cdkContextMenuDisabled", !(ctx_r2.treeConfig == null ? null : ctx_r2.treeConfig.contextMenuConfig == null ? null : ctx_r2.treeConfig.contextMenuConfig.enableContextMenu))("cdkContextMenuTriggerFor", menu_r6)("cdkContextMenuTriggerData", i0.ɵɵpureFunction1(16, _c2, node_r8))("ngClass", node_r8.class);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("data-test-id", "treeExpand_" + ctx_r2.getNodeId(node_r8.title))("id", "treeExpand_" + node_r8.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r2.treeControl.isExpanded(node_r8) ? "mat_solid:keyboard_arrow_down" : "mat_solid:keyboard_arrow_right");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r8.checkbox);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r8.icon);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.expandableNodeTemplateRef() ? 6 : 7);
  }
}
function TreeViewComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mycdk-context-menu", 15);
  }
  if (rf & 2) {
    const node_r10 = ctx.node;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("node", node_r10)("menuConfig", ctx_r2.treeConfig == null ? null : ctx_r2.treeConfig.contextMenuConfig)("defaultMenuItems", ctx_r2.defaultContextMenuItems)("menuItemClick", ctx_r2.menuItemClicked.bind(ctx_r2));
  }
}
const SEPARATOR = '&#x29BF;';
class Tree {
  /**
   * Constructor
   */
  constructor() {
    this.visibleNodes = new EventEmitter();
    this._destroyRef = inject(DestroyRef);
    /** Needed by angular material */
    this.treeControl = new FlatTreeControl(node => node.level, node => node.expandable);
    /** Needed by angular material */
    this.hasChild = (_, node) => node.expandable;
    /**
     * Transformer function from tree node to tree flat node, used by angular material
     * Can be extended by providing custom transform function
     * @param node tree node
     * @param level level of that tree node in the tree
     * @returns tree flat node
     */
    this.transformer = (node, level) => {
      let flatNode = {
        expandable: !!node.children && node.children.length > 0,
        title: node.title,
        level: level,
        id: node.id,
        meta: node.meta,
        expanded: node.expanded ?? false
      };
      if (this.transformFunction) {
        flatNode = {
          ...flatNode,
          ...this.transformFunction(node, level)
        };
      }
      return flatNode;
    };
    this.treeFlattener = new MatTreeFlattener(this.transformer, node => node.level, node => node.expandable, node => node.children);
    // Update visible nodes model when expansion model changes
    // this.treeControl.expansionModel.changed.pipe(takeUntilDestroyed()).subscribe(data => {
    //     this.treeControl.dataNodes.forEach((node, index) => {
    //         if (data.added.includes(node)) {
    //             let descendants: TreeFlatNode[] = [];
    //             function iterateExpandedNode(
    //                 descendants: TreeFlatNode[],
    //                 startIndex: number,
    //                 parentLevel: number
    //             ) {
    //                 for (let i = startIndex + 1; i <= this.treeControl.dataNodes.length; i++) {
    //                     const currentNode = this.treeControl.dataNodes[i];
    //                     if (!currentNode) return;
    //                     if (currentNode.level <= parentLevel) return;
    //                     if (currentNode.level !== parentLevel + 1) continue;
    //                     descendants.push(currentNode);
    //                     if (this.treeControl.isExpanded(currentNode)) {
    //                         iterateExpandedNode.bind(this)(descendants, i, currentNode.level);
    //                     }
    //                 }
    //             }
    //             if (this.treeControl.isExpanded(node))
    //                 iterateExpandedNode.bind(this)(descendants, index, node.level);
    //             this._visibleNodesModel.select(...descendants);
    //         } else if (data.removed.includes(node)) {
    //             let descendants = this.treeControl.getDescendants(node);
    //             this._visibleNodesModel.deselect(...descendants);
    //         }
    //     });
    // });
  }
  /**
   * The following methods are for persisting the tree expand state
   * after being rebuilt
   */
  rebuildTreeForData(data) {
    // 1. Store currently expanded nodes by some unique identifier (e.g., id)
    const previousExpandedIds = this.treeControl.expansionModel.selected.map(node => node.id);
    this.treeControl.expansionModel.clear();
    // 2. Update the data source
    this._visibleNodesModel = new SelectionModel(true, [], true);
    this._visibleNodesModel.changed.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.visibleNodes.emit(this._visibleNodesModel.selected);
    });
    this.dataSource().data = data;
    // 3. Select level 0 nodes (or any logic you want to implement for visible nodes)
    this.treeControl.dataNodes.forEach(node => {
      if (node.level === 0) {
        this._visibleNodesModel.select(node);
      }
    });
    // 4. Restore the expansion state without collapsing the whole tree
    this.treeControl.dataNodes.forEach(node => {
      if (previousExpandedIds.includes(node.id)) {
        this.expand(node);
      }
    });
  }
  onNodeToggled(node) {
    // Wait for Angular Material to toggle the node
    setTimeout(() => {
      if (!this.treeControl.isExpanded(node)) {
        this.treeControl.expansionModel.deselect(node); // Remove the collapsed node from the expansionModel
      }
    });
  }
  /**
   * Expands the tree node
   * @param node tree flat node
   */
  expand(node) {
    this.treeControl.expand(node);
    this.onNodeToggled(node);
  }
  static {
    this.ɵfac = function Tree_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Tree)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Tree,
      selectors: [["ng-component"]],
      inputs: {
        transformFunction: "transformFunction"
      },
      outputs: {
        visibleNodes: "visibleNodes"
      },
      standalone: false,
      decls: 0,
      vars: 0,
      template: function Tree_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Tree, [{
    type: Component,
    args: [{
      template: ''
    }]
  }], () => [], {
    visibleNodes: [{
      type: Output
    }],
    transformFunction: [{
      type: Input
    }]
  });
})();
const defaultMenuItems = [{
  id: 'expand',
  title: 'Expand',
  isVisible: node => node.expandable
}, {
  id: 'expandDescendants',
  title: 'Expand All',
  isVisible: node => node.expandable
}, {
  id: 'collapse',
  title: 'Collapse',
  isVisible: node => node.expandable
}, {
  id: 'collapseDescendants',
  title: 'Collapse All',
  isVisible: node => node.expandable
}];
class TreeViewComponent extends Tree {
  getNodeId(title) {
    return title.replace(' ', '_');
  }
  /**
   * Constructor
   */
  constructor(breakpointObserver) {
    super();
    this.breakpointObserver = breakpointObserver;
    this.treeNodeClick = new EventEmitter();
    this.treeNodeSelectionChange = new EventEmitter();
    this.menuItemClick = new EventEmitter();
    this.dropListDrop = new EventEmitter();
    this.leafNodeTemplateRef = contentChild('leafNode');
    this.expandableNodeTemplateRef = contentChild('expandableNode');
    /** Default context menu items */
    this.defaultContextMenuItems = defaultMenuItems;
    /** Delay (in millisec) to expand the node when hovered over while another node is being dragged over it */
    this.expandDelay = 1000;
    /** Indicates the direction in which the user is dragging the element along each axis */
    this.delta = new BehaviorSubject({
      x: 0,
      y: 0
    });
    this.treeNodePaddingIndent = 40;
    // rebuild the tree after the data changes
    // to sync it with expanded view of the tree (before the data change)
    effect(() => {
      if (this.dataSource()) {
        this.rebuildTreeForData(this.dataSource().data);
      }
    }, {
      allowSignalWrites: true
    });
    // it is run when a node is selected from the parent
    effect(() => {
      if (this.selectNodeId()) {
        const id = this.selectNodeId();
        let flatTreeNode = this.treeControl.dataNodes.find(n => n.id === id);
        if (!flatTreeNode) return;
        // set new selected node
        this.selectedNode = flatTreeNode;
        this.treeNodeSelectionChange.emit(this.selectedNode);
      }
    });
  }
  /**
   * ngOnInit
   */
  ngOnInit() {
    this.dataSource = computed(() => {
      return new MatTreeFlatDataSource(this.treeControl, this.treeFlattener, this.data());
    });
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]).subscribe(result => {
      if (result.breakpoints[Breakpoints.XSmall]) {
        this.treeNodePaddingIndent = 10;
      } else if (result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.Medium]) {
        this.treeNodePaddingIndent = 20;
      } else if (result.breakpoints[Breakpoints.Large]) {
        this.treeNodePaddingIndent = 30;
      } else {
        this.treeNodePaddingIndent = 40;
      }
    });
  }
  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    if (this.delta) this.delta.complete();
  }
  preselectNodeId() {
    const id = this.selectNodeId();
    if (!this.dataSource()) {
      return;
    }
    let flatTreeNode = this.treeControl.dataNodes.find(n => n.id === id);
    if (!flatTreeNode) return;
    // set new selected node
    this.selectedNode = flatTreeNode;
    this.treeNodeSelectionChange.emit(this.selectedNode);
    // expanding parents of the new selected node recursively
    while (flatTreeNode.level > 0) {
      let parentNode = this.getParentNode(flatTreeNode);
      if (!parentNode) return;
      this.expand(parentNode);
      flatTreeNode = parentNode;
    }
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Methods
  // -----------------------------------------------------------------------------------------------------
  rebuildTreeForData(data) {
    super.rebuildTreeForData(data);
    setTimeout(() => {
      this.preselectNodeId();
    }, 500);
  }
  /**
   * Function called when a tree node is clicked
   * @param node tree flat node
   */
  treeNodeClicked(node) {
    if (node.checkbox) {
      if (this.selectedNode !== node) {
        if (this.treeConfig?.canChangeTreeNodeSelection) {
          let subscription = this.treeConfig?.canChangeTreeNodeSelection(node).pipe(takeUntilDestroyed(this._destroyRef)).subscribe({
            next: value => {
              if (value) {
                this.selectedNode = node;
                this.treeNodeSelectionChange.emit(this.selectedNode);
                subscription.unsubscribe();
              }
            }
          });
        } else {
          this.selectedNode = node;
          this.treeNodeSelectionChange.emit(this.selectedNode);
        }
      } else {
        if (this.treeConfig.allowNodeDeselection) {
          this.selectedNode = null;
          this.treeNodeSelectionChange.emit(this.selectedNode);
        }
      }
    }
    this.treeNodeClick.emit(node);
  }
  checkBoxChange(event, node) {
    // if (!event.checked && !this.treeConfig.allowNodeDeselection) {
    //     event.source.checked = true;
    // }
    event.source.checked = !event.checked;
  }
  /**
   * Function to get the parent node of a tree node
   * @param node tree flat node
   */
  getParentNode(node) {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Context menu functions start
  // -----------------------------------------------------------------------------------------------------
  /**
   * Function called when a context menu item is clicked of a tree node
   * @param node tree flat node
   * @param menuItem context menu item object that was clicked
   */
  menuItemClicked(node, menuItem) {
    // first handles the default menu items (if any), and then the custom items provided by the user
    switch (menuItem.id) {
      case 'expand':
        this.expand(node);
        break;
      case 'expandDescendants':
        this.expandAll(node);
        break;
      case 'collapse':
        this.collapse(node);
        break;
      case 'collapseDescendants':
        this.collapseAll(node);
        break;
      default:
        this.menuItemClick.emit({
          node,
          menuItem
        });
        break;
    }
  }
  /**
   * Collapses the tree node
   * @param node tree flat node
   */
  collapse(node) {
    this.treeControl.collapse(node);
    this.onNodeToggled(node);
  }
  /**
   * Expands the tree node recursively
   * @param node tree flat node
   */
  expandAll(node) {
    this.treeControl.expandDescendants(node);
    this.onNodeToggled(node);
  }
  /**
   * Collapses the tree node recursively
   * @param node tree flat node
   */
  collapseAll(node) {
    this.treeControl.collapseDescendants(node);
    this.onNodeToggled(node);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Context menu functions end
  // -----------------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------------------
  // @ Drag and drop functions start
  // -----------------------------------------------------------------------------------------------------
  getDropErrorMsg() {
    let errorMessage = 'Items can only be moved within the same level';
    let customErrorMessage = this.treeConfig.dragDropConfig.validateDropErrorMessage;
    if (customErrorMessage) {
      if (typeof customErrorMessage === 'string') errorMessage = customErrorMessage;else errorMessage = customErrorMessage();
    }
    return errorMessage;
  }
  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event) {
    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) return;
    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this._visibleNodesModel.selected;
    // deep clone the data source so we can mutate it
    const changedData = cloneDeep(this.dataSource().data);
    // recursive find function to find siblings of node
    function findNodeSiblings(arr, id) {
      let result, subResult;
      arr.forEach((item, i) => {
        if (item.id === id) {
          result = arr;
        } else if (item.children) {
          subResult = findNodeSiblings(item.children, id);
          if (subResult) result = subResult;
        }
      });
      return result;
    }
    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    let newSiblings = findNodeSiblings(changedData, nodeAtDest.id);
    if (!newSiblings) return;
    const insertIndex = newSiblings.findIndex(s => s.id === nodeAtDest.id);
    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert = siblings.splice(siblingIndex, 1)[0];
    if (nodeAtDest.id === nodeToInsert.id) return;
    // ensure validity of drop - must be same level
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find(n => nodeAtDest.id === n.id);
    if (this.treeConfig?.dragDropConfig?.validateDrop && !this.treeConfig?.dragDropConfig?.allowDrop(node, nodeAtDestFlatNode)
    // nodeAtDestFlatNode.level !== node.level
    ) {
      alert(this.getDropErrorMsg());
      return;
    }
    // insert node
    newSiblings.splice(insertIndex, 0, nodeToInsert);
    // emit change to the parent
    this.dropListDrop.emit(newSiblings);
    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);
  }
  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    // this.dragging = true;
  }
  dragEnd(event) {
    this.changeCursor(event.source.element.nativeElement);
    // this.dragging = false;
  }
  dragMove(event) {
    this.delta.next(event.delta);
  }
  dragHover(event, node) {
    // the tree node is not expandable or the tree node is already expanded, then return
    if (!node.expandable || this.treeControl.isExpanded(node)) return;
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.expand(node);
        this.shiftNodesWhenNodeOpens(event, node);
      }, this.expandDelay);
    }
  }
  dragHoverEnd(node) {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }
  shiftNodesWhenNodeOpens(event, node) {
    let parentLevel = this.treeControl.getLevel(node);
    let noOfChildren = this.treeControl.getDescendants(node).filter(child => child.level == parentLevel + 1).length;
    let parentElement = event.target;
    parentElement.style.transform = 'translate3d(0px, 0px, 0px)';
    let delta = this.delta.getValue();
    setTimeout(() => {
      let i = 0;
      while (i < noOfChildren) {
        let sibling = parentElement.nextElementSibling;
        sibling.style.transform = 'translate3d(0px, 48px, 0px)';
        i++;
        parentElement = sibling;
      }
      let placeholderElement = document.getElementsByClassName('cdk-drag-placeholder')[0];
      let currentY = placeholderElement.style.transform.split(',')[1].trim().slice(0, -2);
      let newY = delta.y === 1 ? parseInt(currentY) + 1 * 48 : parseInt(currentY) - noOfChildren * 48;
      placeholderElement.style.transform = 'translate3d(0px, ' + newY + 'px, 0px)';
    });
  }
  changeCursor(event, type = 'default') {
    let classes;
    if (event instanceof HTMLElement) classes = event.classList;else classes = event.target.classList;
    if (type === 'default') classes.remove('cursorMove');else classes.add('cursorMove');
  }
  static {
    this.ɵfac = function TreeViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TreeViewComponent)(i0.ɵɵdirectiveInject(i1.BreakpointObserver));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TreeViewComponent,
      selectors: [["custom-tree"]],
      contentQueries: function TreeViewComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.leafNodeTemplateRef, _c0, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.expandableNodeTemplateRef, _c1, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      inputs: {
        data: "data",
        treeConfig: "treeConfig",
        selectNodeId: "selectNodeId"
      },
      outputs: {
        treeNodeClick: "treeNodeClick",
        treeNodeSelectionChange: "treeNodeSelectionChange",
        menuItemClick: "menuItemClick",
        dropListDrop: "dropListDrop"
      },
      exportAs: ["customTree"],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 4,
      consts: [["menu", ""], ["cdkDropList", "", "cdkDropListLockAxis", "y", "cdkDropListOrientation", "vertical", 1, "custom-tree", 3, "cdkDropListDropped", "dataSource", "treeControl", "cdkDropListDisabled"], ["matTreeNodePadding", "", "cdkDrag", "", "cdkDragBoundary", ".custom-tree", 3, "data-test-id", "id", "matTreeNodePaddingIndent", "cdkDragData", "selectedNode", "cdkContextMenuDisabled", "cdkContextMenuTriggerFor", "cdkContextMenuTriggerData", "ngClass", "cdkDragStarted", "cdkDragReleased", "cdkDragMoved", "mouseenter", "mouseleave", "mousedown", "mouseup", "click", 4, "matTreeNodeDef"], ["matTreeNodePadding", "", "cdkDrag", "", "cdkDragBoundary", ".custom-tree", 3, "data-test-id", "id", "matTreeNodePaddingIndent", "cdkDragData", "selectedNode", "cdkContextMenuDisabled", "cdkContextMenuTriggerFor", "cdkContextMenuTriggerData", "ngClass", "cdkDragStarted", "cdkDragReleased", "cdkDragMoved", "mouseenter", "mouseleave", "mousedown", "mouseup", "click", 4, "matTreeNodeDef", "matTreeNodeDefWhen"], ["matTreeNodePadding", "", "cdkDrag", "", "cdkDragBoundary", ".custom-tree", 3, "cdkDragStarted", "cdkDragReleased", "cdkDragMoved", "mouseenter", "mouseleave", "mousedown", "mouseup", "click", "data-test-id", "id", "matTreeNodePaddingIndent", "cdkDragData", "cdkContextMenuDisabled", "cdkContextMenuTriggerFor", "cdkContextMenuTriggerData", "ngClass"], [1, "tree-node-container"], ["mat-icon-button", "", "disabled", "", 1, "chevron-button"], [3, "data-test-id", "id", "checked", "change", 4, "ngIf"], ["class", "icon-button my-auto", 3, "svgIcon", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "my-auto", 3, "innerHTML"], [3, "change", "data-test-id", "id", "checked"], [1, "icon-button", "my-auto", 3, "svgIcon"], ["mat-icon-button", "", "matTreeNodeToggle", "", 1, "chevron-button", 3, "click", "data-test-id", "id"], [3, "svgIcon"], [3, "node", "menuConfig", "defaultMenuItems", "menuItemClick"]],
      template: function TreeViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "mat-tree", 1);
          i0.ɵɵlistener("cdkDropListDropped", function TreeViewComponent_Template_mat_tree_cdkDropListDropped_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.drop($event));
          });
          i0.ɵɵtemplate(1, TreeViewComponent_mat_tree_node_1_Template, 7, 15, "mat-tree-node", 2)(2, TreeViewComponent_mat_tree_node_2_Template, 8, 18, "mat-tree-node", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, TreeViewComponent_ng_template_3_Template, 1, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("dataSource", ctx.dataSource())("treeControl", ctx.treeControl)("cdkDropListDisabled", !(ctx.treeConfig == null ? null : ctx.treeConfig.dragDropConfig == null ? null : ctx.treeConfig.dragDropConfig.enableDragDrop));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("matTreeNodeDefWhen", ctx.hasChild);
        }
      },
      dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, MatTreeModule, i3.MatTreeNodeDef, i3.MatTreeNodePadding, i3.MatTreeNodeToggle, i3.MatTree, i3.MatTreeNode, MatButtonModule, i4.MatIconButton, MatIconModule, i5.MatIcon, MatMenuModule, CdkContextMenuTrigger, MycdkContextMenuComponent, DragDropModule, i6.CdkDropList, i6.CdkDrag, MatCheckboxModule, i7.MatCheckbox],
      styles: [".icon-button[_ngcontent-%COMP%]{margin-right:.5rem}.chevron-button[_ngcontent-%COMP%]{margin-right:.25rem}.tree-node-container[_ngcontent-%COMP%]{display:flex}.mat-tree-node[_ngcontent-%COMP%]{--mdc-checkbox-state-layer-size: 1.5rem;-webkit-user-select:none;user-select:none}.mat-tree-node[_ngcontent-%COMP%]   .mdc-checkbox[_ngcontent-%COMP%]{padding-block:0px}.mat-tree-node[_ngcontent-%COMP%]   .mat-mdc-checkbox[_ngcontent-%COMP%]{display:inline-block!important}.mat-tree-node.cdk-drag-preview[_ngcontent-%COMP%]{@apply text-secondary !important;box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-tree-node.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:1;position:relative}.mat-tree-node.cdk-drag-placeholder[_ngcontent-%COMP%]:after{content:\"\";position:absolute;inset:0;border:1px dashed;background-color:#f0f0f0}.mat-tree-node.cursorMove[_ngcontent-%COMP%]{cursor:move}.cdk-drop-list-dragging[_ngcontent-%COMP%]   .mat-tree-node[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .2s cubic-bezier(0,0,.2,1)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TreeViewComponent, [{
    type: Component,
    args: [{
      selector: 'custom-tree',
      exportAs: 'customTree',
      standalone: true,
      imports: [CommonModule, MatTreeModule, MatButtonModule, MatIconModule, MatMenuModule, CdkContextMenuTrigger, MycdkContextMenuComponent, DragDropModule, MatCheckboxModule],
      template: "<mat-tree\n    class=\"custom-tree\"\n    [dataSource]=\"dataSource()\"\n    [treeControl]=\"treeControl\"\n    cdkDropList\n    cdkDropListLockAxis=\"y\"\n    cdkDropListOrientation=\"vertical\"\n    [cdkDropListDisabled]=\"!treeConfig?.dragDropConfig?.enableDragDrop\"\n    (cdkDropListDropped)=\"drop($event)\">\n    <!-- TEMPLATE FOR LEAF NODES -->\n    <mat-tree-node\n        *matTreeNodeDef=\"let node\"\n        [data-test-id]=\"'treeNode_' + getNodeId(node.title)\"\n        [id]=\"'treeNode_' + getNodeId(node.title)\"\n        matTreeNodePadding\n        [matTreeNodePaddingIndent]=\"treeNodePaddingIndent\"\n        cdkDrag\n        cdkDragBoundary=\".custom-tree\"\n        [cdkDragData]=\"node\"\n        (cdkDragStarted)=\"dragStart()\"\n        (cdkDragReleased)=\"dragEnd($event)\"\n        (cdkDragMoved)=\"dragMove($event)\"\n        (mouseenter)=\"dragHover($event, node)\"\n        (mouseleave)=\"dragHoverEnd(node)\"\n        (mousedown)=\"changeCursor($event, 'move')\"\n        (mouseup)=\"changeCursor($event, 'default')\"\n        (click)=\"treeNodeClicked(node)\"\n        [class.selectedNode]=\"selectedNode && selectedNode.id && selectedNode.id === node.id\"\n        [cdkContextMenuDisabled]=\"!treeConfig?.contextMenuConfig?.enableContextMenu\"\n        [cdkContextMenuTriggerFor]=\"menu\"\n        [cdkContextMenuTriggerData]=\"{ node: node }\"\n        [ngClass]=\"node.class\">\n        <div class=\"tree-node-container\">\n            <!-- disabled button to provide padding for tree leaf -->\n            <button mat-icon-button disabled class=\"chevron-button\"></button>\n\n            <!-- checkbox for selecting node -->\n            <mat-checkbox\n                *ngIf=\"node.checkbox\"\n                [data-test-id]=\"'toggle_' + getNodeId(node.title)\"\n                [id]=\"'toggle_' + getNodeId(node.title)\"\n                (change)=\"checkBoxChange($event, node)\"\n                [checked]=\"selectedNode && selectedNode.id && selectedNode.id === node.id\">\n            </mat-checkbox>\n\n            <!-- custom icon provided by user -->\n            <mat-icon\n                *ngIf=\"node.icon\"\n                class=\"icon-button my-auto\"\n                svgIcon=\"{{ node.icon }}\"></mat-icon>\n\n            <!-- node template -->\n            @if (leafNodeTemplateRef()) {\n            <ng-container\n                [ngTemplateOutlet]=\"leafNodeTemplateRef()\"\n                [ngTemplateOutletContext]=\"{ $implicit: node }\"></ng-container>\n            } @else {\n            <span class=\"my-auto\" [innerHTML]=\"node.title\"></span>\n            }\n        </div>\n    </mat-tree-node>\n\n    <!-- TEMPLATE FOR EXPANDABLE NODES -->\n    <mat-tree-node\n        *matTreeNodeDef=\"let node; when: hasChild\"\n        [data-test-id]=\"'treeNode_' + getNodeId(node.title)\"\n        [id]=\"'treeNode_' + getNodeId(node.title)\"\n        matTreeNodePadding\n        [matTreeNodePaddingIndent]=\"treeNodePaddingIndent\"\n        cdkDrag\n        cdkDragBoundary=\".custom-tree\"\n        [cdkDragData]=\"node\"\n        (cdkDragStarted)=\"dragStart()\"\n        (cdkDragReleased)=\"dragEnd($event)\"\n        (cdkDragMoved)=\"dragMove($event)\"\n        (mouseenter)=\"dragHover($event, node)\"\n        (mouseleave)=\"dragHoverEnd(node)\"\n        (mousedown)=\"changeCursor($event, 'move')\"\n        (mouseup)=\"changeCursor($event, 'default')\"\n        (click)=\"treeNodeClicked(node)\"\n        [class.selectedNode]=\"selectedNode && selectedNode.id && selectedNode.id === node.id\"\n        [cdkContextMenuDisabled]=\"!treeConfig?.contextMenuConfig?.enableContextMenu\"\n        [cdkContextMenuTriggerFor]=\"menu\"\n        [cdkContextMenuTriggerData]=\"{ node: node }\"\n        [ngClass]=\"node.class\">\n        <div class=\"tree-node-container\">\n            <!-- expand/collapse button -->\n            <button\n                class=\"chevron-button\"\n                [data-test-id]=\"'treeExpand_' + getNodeId(node.title)\"\n                [id]=\"'treeExpand_' + node.title\"\n                mat-icon-button\n                matTreeNodeToggle\n                (click)=\"onNodeToggled(node)\">\n                <mat-icon\n                    [svgIcon]=\"\n                        treeControl.isExpanded(node)\n                            ? 'mat_solid:keyboard_arrow_down'\n                            : 'mat_solid:keyboard_arrow_right'\n                    \">\n                </mat-icon>\n            </button>\n\n            <!-- checkbox for selecting node -->\n            <mat-checkbox\n                *ngIf=\"node.checkbox\"\n                [data-test-id]=\"'toggle_' + getNodeId(node.title)\"\n                [id]=\"'toggle_' + getNodeId(node.title)\"\n                (change)=\"checkBoxChange($event, node)\"\n                [checked]=\"selectedNode && selectedNode.id && selectedNode.id === node.id\">\n            </mat-checkbox>\n\n            <!-- custom icon provided by user -->\n            <mat-icon\n                *ngIf=\"node.icon\"\n                class=\"icon-button my-auto\"\n                svgIcon=\"{{ node.icon }}\"></mat-icon>\n\n            <!-- node template -->\n            @if (expandableNodeTemplateRef()) {\n            <ng-container\n                [ngTemplateOutlet]=\"expandableNodeTemplateRef()\"\n                [ngTemplateOutletContext]=\"{ $implicit: node }\"></ng-container>\n            } @else {\n            <span class=\"my-auto\" [innerHTML]=\"node.title\"></span>\n            }\n        </div>\n    </mat-tree-node>\n</mat-tree>\n\n<!-- Context menu (on right click of tree node) -->\n<ng-template #menu let-node=\"node\">\n    <mycdk-context-menu\n        [node]=\"node\"\n        [menuConfig]=\"treeConfig?.contextMenuConfig\"\n        [defaultMenuItems]=\"defaultContextMenuItems\"\n        [menuItemClick]=\"menuItemClicked.bind(this)\"></mycdk-context-menu>\n</ng-template>\n",
      styles: [".icon-button{margin-right:.5rem}.chevron-button{margin-right:.25rem}.tree-node-container{display:flex}.mat-tree-node{--mdc-checkbox-state-layer-size: 1.5rem;-webkit-user-select:none;user-select:none}.mat-tree-node .mdc-checkbox{padding-block:0px}.mat-tree-node .mat-mdc-checkbox{display:inline-block!important}.mat-tree-node.cdk-drag-preview{@apply text-secondary !important;box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-tree-node.cdk-drag-placeholder{opacity:1;position:relative}.mat-tree-node.cdk-drag-placeholder:after{content:\"\";position:absolute;inset:0;border:1px dashed;background-color:#f0f0f0}.mat-tree-node.cursorMove{cursor:move}.cdk-drop-list-dragging .mat-tree-node:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.cdk-drag-animating{transition:transform .2s cubic-bezier(0,0,.2,1)}\n"]
    }]
  }], () => [{
    type: i1.BreakpointObserver
  }], {
    treeNodeClick: [{
      type: Output
    }],
    treeNodeSelectionChange: [{
      type: Output,
      args: ['treeNodeSelectionChange']
    }],
    menuItemClick: [{
      type: Output
    }],
    dropListDrop: [{
      type: Output
    }],
    data: [{
      type: Input
    }],
    treeConfig: [{
      type: Input
    }],
    selectNodeId: [{
      type: Input
    }]
  });
})();

/*
 * Public API Surface of tree-view
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SEPARATOR, Tree, TreeViewComponent };
